export class AusCredentialValidationApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async validateFreddieCredentials({ username, password }) {
    return this.#http.post('aus/validate/freddie', { username, password });
  }

  async validateFreddieLcaCredentials({ username, password }) {
    return this.#http.post('aus/validate/freddie-lca', { username, password });
  }
}
